/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MessageViewFileGroupDto } from './messageViewFileGroupDto';
import { MessageViewFileDto } from './messageViewFileDto';
import { MessageViewEmodjiDto } from './messageViewEmodjiDto';


export interface MessageViewDto { 
    /**
     * Уникальный id сообщения
     */
    messageId: string;
    /**
     * Временная метка сообщения
     */
    timestamp: number;
    /**
     * id пользователя-создателя сообщения
     */
    senderUserId: string;
    /**
     * имя пользователя-создателя сообщения
     */
    senderUserName: string;
    /**
     * Тип сообщения (например, text/emodji/file)
     */
    messageType: string;
    /**
     * строка c текстом сообщения
     */
    messageText: string;
    /**
     * Дата создания сообщения
     */
    createdAt: number;
    /**
     * ид родительского сообщения
     */
    replyMessageId?: string | null;
    /**
     * цитата родительского сообщения
     */
    replyMessageText?: string | null;
    /**
     * Список реакций
     */
    emodjies?: Array<MessageViewEmodjiDto> | null;
    file?: MessageViewFileDto;
    fileGroup?: MessageViewFileGroupDto;
    /**
     * Признак, что сообщение доставлено хотя бы одному из участников
     */
    deliveredToAnyOne: boolean;
    /**
     * Признак, что сообщение прочитано хотя бы одним из участников
     */
    readAnyOne: boolean;
    /**
     * ContentType группы файлов
     */
    contentType?: string | null;
}

